import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Login';
import ResetPassword from './Pages/ResetPassword';
import TheSMS from './Pages/TheSMS';
import Applications from './Pages/Applications';
import Interviews from './Pages/Interviews';
import Invoicing from './Pages/Invoicing';
import Profile from './Pages/Profile';
import Settings from './Pages/Settings';
import ActivityLogs from './Pages/ActivityLogs';
import Admins from './Pages/Admins';
import ActiveStudents from './Pages/ActiveStudents';
import GraduatedStudents from './Pages/GraduatedStudents';
import LearningBreaks from './Pages/LearningBreaks';
import NeverJoined from './Pages/NeverJoined';
import OtherStudents from './Pages/OtherStudents';
import StudentsGraduating from './Pages/StudentsGraduating';
import FeeReminders from './Pages/FeeReminders';
import MediaConsent from './Pages/MediaConsent';
import MediaConsentNew from './Pages/MediaConsentNew';
import MediaConsentResponse from './Pages/MediaConsentResponse';
import DailyBriefing from './Pages/DailyBriefing';
import TheEmails from './Pages/TheEmails';
import ViewStudent from './Pages/ViewStudent';
import Income from './Pages/Finance/Income';
import AdmissionFees from './Pages/Finance/AdmissionFees';
import Invoices from './Pages/Finance/Invoices';
import ProjectedIncome from './Pages/Finance/ProjectedIncome';
import ViewInvoice from './Pages/Finance/ViewInvoice';
import ViewFixedBill from './Pages/Finance/ViewFixedBill';
import Branches from './Pages/Branches';
import OtherIncome from './Pages/Finance/OtherIncome';
import Vendors from './Pages/Finance/Vendors';
import Bills from './Pages/Finance/Bills';
import PayBills from './Pages/Finance/PayBills';
import Expenses from './Pages/Finance/Expenses';
import Requisitions from './Pages/Finance/Requisitions';
import RequisitionApprovals from './Pages/Finance/RequisitionApprovals';
import Debts from './Pages/Finance/Debts';
import FinanceReports from './Pages/Finance/FinanceReports';
import AssetRegister from './Pages/Finance/AssetRegister';
import Employees from './Pages/HR/Employees';
import PaySalaries from './Pages/HR/PaySalaries';
import ViewEmployee from './Pages/HR/ViewEmployee';
import InstructorProfile from './Pages/HR/InstructorProfile';
import Courses from './Pages/Academic/Courses';
import CourseDetails from './Pages/Academic/CourseDetails';
import Intakes from './Pages/Academic/Intakes';
import Sessions from './Pages/Academic/Sessions';
import Classess from './Pages/Academic/Classess';
import Instructors from './Pages/HR/Instructors';
import Darassa from './Pages/Academic/Darassa';
import ViewAllClasses from './Pages/Academic/ViewAllClasses';
import AddIncome from './Pages/Finance/AddIncome';
import AddInvoice from './Pages/Finance/AddInvoice';
import ViewReceipt from './Pages/Finance/ViewReceipt';
import Certificate from './Pages/Certificate';
import SchoolId from './Pages/SchoolIdComp';

// 
import MarketingBudget from './Pages/Marketing/MarketingBudget';
import Campaigns from './Pages/Marketing/Campaigns';
import Targets from './Pages/Targets/Targets';
import TargetReport from './Pages/Targets/TargetReport';
import TargetAnalysis from './Pages/Targets/TargetAnalysis';
import StudentSources from './Pages/Analytics/StudentSources';
import ConvBySource from './Pages/Analytics/ConvBySource';
import TrendsOverTime from './Pages/Analytics/TrendsOverTime';
import CourseBySource from './Pages/Analytics/CourseBySource';
import DemographicsBySource from './Pages/Analytics/DemographicsBySource';
import SessionTimeDemand from './Pages/Analytics/SessionTimeDemand';
import ApplicationToAdmTime from './Pages/Analytics/ApplicationToAdmTime';
import CampusType from './Pages/Analytics/CampusType';
import DropOffAnalysis from './Pages/Analytics/DropOffAnalysis';
import DistributionByCountry from './Pages/Analytics/DistributionByCountry';
import CountryAnalysis from './Pages/Analytics/CountryAnalysis';
import Devs from './Pages/Lab/Devs';
import ExtendedTeams from './Pages/Lab/ExtendedTeams';
import ManagedService from './Pages/Lab/ManagedService';
import ManagedProduct from './Pages/Lab/ManagedProduct';
import LabOnboarding from './Pages/Lab/LabOnboarding';
import ViewLabClient from './Pages/Lab/ViewLabClient';
import LabEmails from './Pages/Lab/LabEmails';
import MilestoneTracker from './Pages/Analytics/MilestoneTracker';
import InterviewMeetingPage from './Pages/InterviewMeetingPage';
import ProtectedRoute from './ProtectedRoute';





function App() {
  const withRoles = (element, allowedAdminTypes = ['admin', 'superAdmin']) => (
    <ProtectedRoute allowedAdminTypes={allowedAdminTypes}>
      {element}
    </ProtectedRoute>
  );


  return (
    <div className="App">   
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />


          {/* anyone who is not logged in should still be able to view the receipt and invoice */}
          <Route path="/view-receipt" element={<ViewReceipt />} />
          <Route path="/view-invoice" element={<ViewInvoice />} />
          <Route path="/view-fixed-bill/:id" element={withRoles(<ViewFixedBill />, ['superAdmin'])} />
          <Route path="/view-student" element={<ViewStudent />} />
          <Route path="/view-certificate" element={<Certificate />} />
          <Route path="/view-school-id" element={<SchoolId />} />
          <Route path="/view-classes" element={<ViewAllClasses />} />
          <Route path="/media-consent/respond/:token" element={<MediaConsentResponse />} />
          <Route path="/meeting/:meetingId" element={<InterviewMeetingPage />} />


          {/* Activate during development */}

          <Route path="/dashboard" element={withRoles(<Dashboard />)} />
          <Route path="/interviews" element={withRoles(<Interviews />)} />
          <Route path="/invoicing" element={withRoles(<Invoicing />)} />
          <Route path="/profile" element={withRoles(<Profile />)} />
          <Route path="/activity-logs" element={withRoles(<ActivityLogs />, ['superAdmin'])} />
          <Route path="/settings" element={withRoles(<Settings />, ['superAdmin'])} />
          <Route path="/admins" element={withRoles(<Admins />, ['superAdmin'])} />

          <Route path="/courses" element={withRoles(<Courses />, ['superAdmin'])} />
          <Route path="/course-details/:courseId" element={withRoles(<CourseDetails />, ['superAdmin'])} />
          <Route path="/intakes" element={withRoles(<Intakes />)} />
          <Route path="/session-settings" element={withRoles(<Sessions />)} />
          <Route path="/classes" element={withRoles(<Classess />)} />
          <Route path="/instructors" element={withRoles(<Instructors />, ['superAdmin'])} />
          <Route path="/instructors/:id" element={withRoles(<InstructorProfile />, ['superAdmin'])} />
          <Route path="/branches" element={withRoles(<Branches />, ['superAdmin'])} />
          <Route path="/darasa" element={withRoles(<Darassa />)} />

          <Route path="/applications" element={withRoles(<Applications />)} />
          <Route path="/active-students" element={withRoles(<ActiveStudents />)} />
          <Route path="/learning-breaks" element={withRoles(<LearningBreaks />)} />
          <Route path="/graduated-students" element={withRoles(<GraduatedStudents />)} />
          <Route path="/students-graduating" element={withRoles(<StudentsGraduating />)} />
          <Route path="/never-joined" element={withRoles(<NeverJoined />)} />
          <Route path="/other-students" element={withRoles(<OtherStudents />)} />

          <Route path="/sms" element={withRoles(<TheSMS />)} />
          <Route path="/emails" element={withRoles(<TheEmails />)} />
          <Route path="/fee-reminders" element={withRoles(<FeeReminders />)} />
          <Route path="/media-consent" element={withRoles(<MediaConsent />)} />
          <Route path="/media-consent/new" element={withRoles(<MediaConsentNew />)} />
          <Route path="/daily-briefing" element={withRoles(<DailyBriefing />)} />

          <Route path="/income" element={withRoles(<Income />)} />
          <Route path="/admission-fees" element={withRoles(<AdmissionFees />)} />
          <Route path="/sent-invoices" element={withRoles(<Invoices />)} />
          <Route path="/projected-income" element={withRoles(<ProjectedIncome />, ['superAdmin'])} />
          <Route path="/other-income" element={withRoles(<OtherIncome />, ['superAdmin'])} />
          <Route path="/vendors" element={withRoles(<Vendors />, ['superAdmin'])} />
          <Route path="/fixed-bills" element={withRoles(<Bills />, ['superAdmin'])} />
          <Route path="/pay-bills" element={withRoles(<PayBills />, ['superAdmin'])} />
          <Route path="/expenses" element={withRoles(<Expenses />, ['superAdmin'])} />
          <Route path="/requisitions" element={withRoles(<Requisitions />)} />
          <Route path="/requisition-approvals" element={withRoles(<RequisitionApprovals />, ['superAdmin'])} />
          <Route path="/debts-loans" element={withRoles(<Debts />, ['superAdmin'])} />
          <Route path="/finance-reports" element={withRoles(<FinanceReports />, ['superAdmin'])} />
          <Route path="/assets" element={withRoles(<AssetRegister />, ['superAdmin'])} />
          <Route path="/add-income" element={withRoles(<AddIncome />)} />
          <Route path="/send-invoice" element={withRoles(<AddInvoice />)} />
          <Route path="/employees" element={withRoles(<Employees />, ['superAdmin'])} />
          <Route path="/pay-salaries" element={withRoles(<PaySalaries />, ['superAdmin'])} />
          <Route path="/view-employee/:id" element={withRoles(<ViewEmployee />, ['superAdmin'])} />


          {/* new stuff */}
          <Route path="/fee-balances" element={withRoles(<FeeReminders />)} />
          <Route path="/marketing-budget" element={withRoles(<MarketingBudget />, ['superAdmin'])} />
          <Route path="/campaigns" element={withRoles(<Campaigns />, ['superAdmin'])} />
          <Route path="/monthly-targets" element={withRoles(<Targets />, ['superAdmin'])} />
          <Route path="/target-reports" element={withRoles(<TargetReport />, ['superAdmin'])} />
          <Route path="/target-analytics" element={withRoles(<TargetAnalysis />, ['superAdmin'])} />

          {/*Analytics */}
          <Route path="/sources-of-students" element={withRoles(<StudentSources />, ['superAdmin'])} />
          <Route path="/conversion-by-source" element={withRoles(<ConvBySource />, ['superAdmin'])} />
          <Route path="/trends-over-time" element={withRoles(<TrendsOverTime />, ['superAdmin'])} />
          <Route path="/course-by-source" element={withRoles(<CourseBySource />, ['superAdmin'])} />
          <Route path="/demographics-by-source" element={withRoles(<DemographicsBySource />, ['superAdmin'])} />
          <Route path="/session-time-demand" element={withRoles(<SessionTimeDemand />, ['superAdmin'])} />
          <Route path="/application-to-adm-time" element={withRoles(<ApplicationToAdmTime />, ['superAdmin'])} />
          <Route path="/campus-type" element={withRoles(<CampusType />, ['superAdmin'])} />
          <Route path="/drop-off-analysis" element={withRoles(<DropOffAnalysis />, ['superAdmin'])} />
          <Route path="/distribution-by-country" element={withRoles(<DistributionByCountry />, ['superAdmin'])} />
          <Route path="/country-analysis" element={withRoles(<CountryAnalysis />, ['superAdmin'])} />

          {/* LAB */}
          <Route path="/devs" element={withRoles(<Devs/>, ['superAdmin'])} />
          <Route path="extended-teams" element={withRoles(<ExtendedTeams/>, ['superAdmin'])} />
          <Route path="managed-service" element={withRoles(<ManagedService/>, ['superAdmin'])} />
          <Route path="managed-products" element={withRoles(<ManagedProduct/>, ['superAdmin'])} />
          <Route path="lab-onboarding" element={withRoles(<LabOnboarding/>, ['superAdmin'])} />
          <Route path="view-lab-client/:id" element={withRoles(<ViewLabClient/>, ['superAdmin'])} />
          <Route path="lab-emails" element={withRoles(<LabEmails/>, ['superAdmin'])} />
          <Route path="/milestones" element={withRoles(<MilestoneTracker/>, ['superAdmin'])} />
          <Route path="/:meetingId" element={<InterviewMeetingPage />} />


        </Routes>       
      </BrowserRouter> 
    </div>
  );
}

export default App;
